import React, { useState } from "react";
import { Box, IconButton, Popover, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LanguageSelector from "../common/LanguageSelector";
import LanguageIcon from "@mui/icons-material/Language";
import Header from "./Header";
import Footer from "./Footer";
import PageHeaderWithBreadcrumbs from "../common/PageHeaderWithBreadcrumbs";

const Layout = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      {/* Tab flottant icône globe en haut à droite, seulement sur mobile */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default Layout;
